import React from 'react';
import { Link } from 'gatsby';

import Html from 'views/components/html';
import Header from 'views/components/header';
import Body from 'views/components/body';
import Contents from 'views/components/contents';
import Breadcrumb from 'views/components/breadcrumb';
import RightTriangleSquare from 'views/components/right-triangle-square';
import BackToTopButton from 'views/components/back-to-top-button';
import Footer from 'views/components/footer';
import { Background, Heading, Table, Summary, AVPiece, LCDPiece, LensPiece, CarPiece, PrecisionPiece, ContainerPiece, Equipment, Contact } from './index.styled';
import title from './assets/title.gif';
import avPiece1 from './assets/av-piece-1.jpg';
import avPiece2 from './assets/av-piece-2.jpg';
import lcdPiece1 from './assets/lcd-piece-1.jpg';
import lensPiece1 from './assets/lens-piece-1.jpg';
import carPiece1 from './assets/car-piece-1.jpg';
import carPiece2 from './assets/car-piece-2.jpg';
import precisionPiece1 from './assets/precision-piece-1.jpg';
import precisionPiece2 from './assets/precision-piece-2.jpg';
import precisionPiece3 from './assets/precision-piece-3.jpg';
import containerPiece1 from './assets/container-piece-1.jpg';
import equipmentLink from './assets/equipment-link.jpg';

const MoldedPiece = () => {
  return (
    <>
      <Html title="成形品" />
      <Header />
      <Body>
        <Contents>
          <Breadcrumb><Link to="/">HOME</Link>　&gt;　成形品</Breadcrumb>
          <Background>
            <Heading>
              <h1><img src={title} alt="成形品" /></h1>
            </Heading>
            <Summary>
              <h2>主要製品一覧</h2>
              <Table>
                <table>
                  <thead>
                  <tr>
                    <th>用途</th>
                    <th>主な材質</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>携帯電話、ゲーム機、AV機器</td>
                    <td>ABS、ABS+PC、PS、PMMA、PC</td>
                  </tr>
                  <tr>
                    <td>液晶用の導光板、飾り板（製品前面）</td>
                    <td>PC、PMMA</td>
                  </tr>
                  <tr>
                    <td>精密部品（プロジェクター、ギヤー）</td>
                    <td>LCP、PPS、POM、PBT</td>
                  </tr>
                  <tr>
                    <td>自動車関連部品</td>
                    <td>ABS、AES、PC、PMMA</td>
                  </tr>
                  <tr>
                    <td>その他</td>
                    <td>PE、PP、PET</td>
                  </tr>
                  </tbody>
                </table>
              </Table>
            </Summary>
            <AVPiece>
              <h2>AV機器部品</h2>
              <div>
                <div>
                  <img src={avPiece1} alt="AV機器部品1" />
                  <ul>
                    <li>・用途：AV機器の前面部分</li>
                    <li>・種類：サイドゲート</li>
                    <li>・サイズ：厚さ10mm、長さ300mm</li>
                    <li>・材質：PMMA（アクリル）</li>
                    <li>・特徴：ゲートは切削仕上げです。（右下）</li>
                  </ul>
                </div>
                <div>
                  <img src={avPiece2} alt="AV機器部品2" />
                  <ul>
                    <li>・用途：AV機器の前面部分</li>
                    <li>・種類：サイドゲート</li>
                    <li>・サイズ：厚さ3mm、長さ200mm</li>
                    <li>・材質：PMMA（アクリル）</li>
                  </ul>
                </div>
              </div>
            </AVPiece>
            <LCDPiece>
              <h2>液晶用の導光板</h2>
              <div>
                <img src={lcdPiece1} alt="液晶用の導光板" />
                <ul>
                  <li>・用途：携帯電話やゲーム機の液晶パネル部分</li>
                  <li>・種類：サイドゲート</li>
                  <li>・サイズ：厚さ0.6mm、大きさ3インチ</li>
                  <li>・材質：PC（ポリカーボネート）</li>
                </ul>
              </div>
            </LCDPiece>
            <LensPiece>
              <h2>レンズ部品</h2>
              <div>
                <img src={lensPiece1} alt="レンズ部品" />
                <ul>
                  <li>・種類：サイドゲート</li>
                  <li>・材質：PC（ポリカーボネート）</li>
                </ul>
              </div>
            </LensPiece>
            <CarPiece>
              <h2>自動車関連部品</h2>
              <div>
                <div>
                  <img src={carPiece1} alt="自動車関連品1" />
                  <ul>
                    <li>・用途：自動車の内装部品</li>
                    <li>・種類：サイドゲート</li>
                    <li>・材質：PC（ポリカーボネート）</li>
                  </ul>
                </div>
                <div>
                  <img src={carPiece2} alt="自動車関連品2" />
                  <ul>
                    <li>・用途：自動車の内装部品</li>
                    <li>・種類：サイドゲート</li>
                    <li>・材質：ABS（左上）、POM（左下）、AES（右上）</li>
                  </ul>
                </div>
              </div>
            </CarPiece>
            <PrecisionPiece>
              <h2>精密成形品</h2>
              <div>
                <div>
                  <img src={precisionPiece1} alt="精密成形品1" />
                  <ul>
                    <li>・用途：プロジェクターなどの 耐熱部分</li>
                    <li>・種類：ピンゲート</li>
                    <li>・材質：PPS</li>
                  </ul>
                </div>
                <div>
                  <img src={precisionPiece2} alt="精密成形品2" />
                  <ul>
                    <li>・用途：プロジェクターなどの 耐熱部分</li>
                    <li>・種類：ピンゲート</li>
                    <li>・材質：LCP</li>
                  </ul>
                </div>
                <div>
                  <img src={precisionPiece3} alt="精密成形品3" />
                  <ul>
                    <li>・用途：モーターなどの軸受け部分</li>
                    <li>・種類：ピンゲート</li>
                    <li>・材質：PPS</li>
                  </ul>
                </div>
              </div>
            </PrecisionPiece>
            <ContainerPiece>
              <h2>容器などの部品</h2>
              <div>
                <img src={containerPiece1} alt="容器などの部品" />
                <ul>
                  <li>・用途：耐薬品性、耐侯性が要求される部分</li>
                  <li>・種類：ピンゲート</li>
                  <li>・材質：PET</li>
                </ul>
              </div>
            </ContainerPiece>
            <Equipment>
              <h2>設備</h2>
              <Link to="/equipment"><img src={equipmentLink} alt="設備" /></Link>
            </Equipment>
            <Contact>
              <h2>お問い合わせ</h2>
              <p>当社への見積もり依頼やお問い合わせは、以下までお願いいたします。<br />どうぞお気軽にお問い合わせください。</p>
              <table>
                <tbody>
                <tr>
                  <th><RightTriangleSquare />&nbsp;TEL</th>
                  <td>06-6747-1118（代）</td>
                </tr>
                <tr>
                  <th><RightTriangleSquare />&nbsp;FAX</th>
                  <td>06-6747-1188</td>
                </tr>
                <tr>
                  <th><RightTriangleSquare />&nbsp;MAIL</th>
                  <td><a href="mailto:info@nonakass.com">info@nonakass.com</a></td>
                </tr>
                </tbody>
              </table>
            </Contact>
          </Background>
          <BackToTopButton />
        </Contents>
      </Body>
      <Footer />
    </>
  );
};

export default MoldedPiece;
